
try { rsstonews.ui.main_BANG_(); } catch (e) { console.error("An error occurred when calling (rsstonews.ui/main!)"); throw(e); }